export type ObserverCallback<T> = (state: T) => void;
export type Keys<T> = (keyof T)[];

export type ActionHandler<T> = (state: T, payload: any) => T;
export type Actions<A extends string, T> = Record<A, ActionHandler<T>>;

export type Subscribe<T> = (observer: ObserverCallback<T>, keys?: Keys<T>) => void;
export type Unsubscribe<T> = (observer: ObserverCallback<T>) => void;
export type Dispatch<A extends string, T> = (actionKey: A, payload?: any) => T | Promise<T>;
export type State<T> = () => T;

export interface Store<T, A extends string> {
    getState: State<T>;
    getPrevState: State<T>;
    subscribe: Subscribe<T>;
    unsubscribe: Unsubscribe<T>;
    dispatch: Dispatch<A, T>;
}

export interface StoreSettings<T, A extends string> {
    actions?: Actions<A, T>;
    initialState: T;
}

export interface Observer<T> {
    callback: ObserverCallback<T>;
    keys?: Keys<T>;
}

export type Observers<T> = Array<Observer<T>>;

export interface BrowserStorageStoreItem<T> {
    value: T;
    expire?: Date;
}

export interface BrowserStorageStoreSettings<T, A extends string> extends StoreSettings<T, A> {
    key: string;
    initAction: A;
    expireInDays?: number;
    excludeProps?: Keys<T>;
}
